export const iconFontAwesomeMapsTrainSubway = (
	<i className="fa-solid fa-train-subway"></i>
);
